import React, { Component } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { wmLoginUsuarioSenha } from "app/redux/actions/LoginActions";
import localStorageService from "app/services/localStorageService";
import { setUserData } from "app/redux/actions/UserActions";
import swal from "sweetalert2";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import ListaPerfis from "./perfis";

const LoginSchema = yup.object().shape({
  usuario: yup.string().required("usuário é obrigatório"),
  senha: yup
    .string()
    .min(3, "senha não pode ser menor que 3 caracteres")
    .required("senha é obrigatória"),
});

class Login extends Component {
  state = {
    showModal: false,
    perfis: [],
  };

  constructor(props) {
    super(props);

    const $auth = localStorageService.getItem("auth_user");

    if ($auth === undefined || $auth === null) {
      this.state = { usuario: "", senha: "", submit: false };
    } else {
      this.state = { usuario: $auth.cdUsuario, senha: $auth.pwUsuario };
    }

    localStorageService.setItem("anoletivo", new Date().getFullYear());
    const $anoletivo = localStorageService.getItem("anoletivo");
  }

  handleChange = (event) => {
    event.persist();
    this.setState({ [event.target.name]: event.target.value });
  };

  setSession = (token) => {
    if (token) {
      localStorage.setItem("wm_token", token);
      axios.defaults.headers.common["Authorization"] = "Portador " + token;
    } else {
      localStorage.removeItem("wm_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  setUser = (user) => {
    localStorageService.setItem("auth_user", user);
  };

  realizaLogin = (usuario) => {
    this.setSession(usuario.cdUsuario);
    this.setUser(usuario);
    setUserData(usuario);

    let path = "";

    switch (usuario.role) {
      case "ADMIN":
      case "SECRETARIA":
      case "FINANCEIRO":
        path = "/dashboard/admin";
        break;
      case "PROFESSOR":
        path = "/dashboard/professor";
        break;
      default:
        path = "/";
        break;
    }

    axios.defaults.headers.common['Authorization'] = `Bearer ${usuario.token}`;    

    window.location.href = path;
  };

  handleSubmit = (value, { isSubmitting }) => {
    this.toggle("submit");

    this.props.wmLoginUsuarioSenha(value, (retorno) => {
      const { type, mensagem, user } = retorno;

      switch (type) {
        case "LOGIN_SUCCESS":
          if (user.length > 1) {
            this.setState({ perfis: user, showModal: true }, () => {
              this.toggle("submit");
            });
          } else {
            this.realizaLogin(user[0]);
          }

          break;
        case "LOGIN_ERROR":
          this.toggle("submit");
          swal.fire("Erro!", mensagem, "warning");
          break;
        default:
          //console.log(retorno);
          break;
      }
    });
  };

  toggle(name) {
    this.setState({
      [name]: !this.state[name],
    });
  }

  toggleModal = () => {
    const { showModal } = this.state;

    this.setState({ showModal: !showModal });
  };

  render() {
    const { perfis, showModal } = this.state;
    return (
      <div
        className="auth-layout-wrap"
        style={{
          backgroundImage:
            "url(https://blobwebmagister.blob.core.windows.net/webmagisterapp/blobapp/bg-webmagister.jpg)",
        }}
      >
        <div className="auth-content">
          <div className="card o-hidden">
            <div className="row">
              <div className="col-md-6">
                <div className="p-4">
                  <div className="auth-logo text-center mb-4">
                    <img
                      src="https://blobwebmagister.blob.core.windows.net/webmagisterapp/blobapp/logo-webmagister.png"
                      alt=""
                    />
                  </div>
                  <h1 className="mb-3 text-18">Log In {this.state.type}</h1>
                  <Formik
                    initialValues={this.state}
                    validationSchema={LoginSchema}
                    onSubmit={this.handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label htmlFor="usuario"> Usuário</label>
                          <input
                            className="form-control form-control-rounded position-relative"
                            type="text"
                            name="usuario"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.usuario}
                          />
                          {errors.usuario && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.usuario}
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="senha"> Senha</label>
                          <input
                            className="form-control form-control-rounded"
                            type="password"
                            name="senha"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.senha}
                          />
                          {errors.senha && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.senha}
                            </div>
                          )}
                        </div>
                        <LaddaButton
                          key="submit"
                          className={
                            "btn btn-rounded btn-primary btn-block mt-2 position-relative"
                          }
                          loading={this.state["submit"]}
                          progress={0.5}
                          onClick={() => {
                            //this.toggle("submit");
                            //console.log(errors);
                            //handleSubmit()
                          }}
                          data-style={EXPAND_RIGHT}
                        >
                          Enviar
                        </LaddaButton>
                      </form>
                    )}
                  </Formik>
                  {/*
                  <div className="mt-3 text-center">
                    <Link to="/session/forgot-password" className="text-muted">
                      <u>Esqueceu a senha?</u>
                    </Link>
                  </div>
                  */}
                </div>
              </div>
              <div
                className="col-md-6 text-center "
                style={{
                  backgroundSize: "contain",
                  backgroundImage:
                    "url(https://blobwebmagister.blob.core.windows.net/webmagisterapp/blobapp/lateral-webmagister.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center right",
                }}
              >
                <div className="pr-3 auth-right"></div>
              </div>
            </div>
          </div>
        </div>
        <ListaPerfis
          showModal={showModal}
          lista={perfis}
          toggleModal={this.toggleModal}
          realizaLogin={this.realizaLogin}
        />        
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  wmLoginUsuarioSenha: PropTypes.func.isRequired,
  usuario: state.usuario,
});

export default connect(mapStateToProps, {
  wmLoginUsuarioSenha,
})(Login);
